<template>
  <div>
    <div class="landing">
      <div class="intro">
        <!-- <span class="greetings">Hi, I am</span> -->
        <div class="name">Baraka</div>
        <div class="name">Dev</div>
        <a href="#a1" class="title">
          <span>Get to know more about me</span>
        </a>
      </div>
      <div class="stars">
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
      </div>
    </div>
    <div id="a1"></div>
  </div>
</template>

<script>
export default {
  props: [],
};
</script>

<style lang="scss" scoped>
@mixin sp-layout {
  @media screen and (max-width: 750px) {
    @content;
  }
}

.landing {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: radial-gradient(ellipse at bottom, #0d1d31 0%, #0c0d13 100%);
  background-image: url("../../assets/vectors/0058.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
}
@font-face {
  font-family: "Monoton";
  font-style: normal;
  font-weight: 400;
  src: url("../../assets/fonts/Monoton-Regular.ttf");
}
.intro {
  margin-left: 150px;
  width: 100%;
}
.greetings {
  font-size: 22px;
  color: #fff;
}
.name {
  font-size: 104px;
  font-weight: 500;
  text-transform: lowercase;
  // color: rgb(0, 0, 0);
  color: #fff;
  margin: 0;
  line-height: 7.5rem;
  font-family: "Monoton";
}
.title {
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 2px;
  color: #fff;
  background-color: #765cd1;
  padding: 8px 8px;
}
@media screen and (max-width: 601px) {
  .intro {
    margin-left: 20px;
  }
  .greetings {
    font-size: 16px;
    color: #fff;
    margin-bottom: -200px;
  }
  .name {
    font-size: 65px;
    font-weight: 500;
    text-shadow: 1px 1px 1px rgb(0, 0, 0);
    text-transform: lowercase;
    // color: rgb(0, 0, 0);
    color: #fff;
    line-height: 5rem;

    font-family: "Monoton";
  }
  .title {
    margin-top: 20px;
    text-transform: uppercase;
    font-size: 10px;
    letter-spacing: 2px;
    color: #fff;

    background-color: #765cd1;
    padding: 8px 8px;
  }
}
@function random_range($min, $max) {
  $rand: random();
  $random_range: $min + floor($rand * (($max - $min) + 1));
  @return $random_range;
}

.stars {
  position: relative;
  top: 0;
  left: -50%;
  width: 100%;
  height: 20%;
  transform: rotate(-45deg);
}

.star {
  $star-count: 70;
  //   --star-color: var(--primary-color);
  --star-color: #fff;
  //   --star-color: #765cd1;
  --star-tail-length: 6em;
  --star-tail-height: 2px;
  --star-width: calc(var(--star-tail-length) / 6);
  --fall-duration: 9s;
  --tail-fade-duration: var(--fall-duration);

  position: absolute;
  top: var(--top-offset);
  //   top: 40;
  left: 0;
  width: var(--star-tail-length);
  height: var(--star-tail-height);
  color: var(--star-color);
  background: linear-gradient(45deg, currentColor, transparent);
  border-radius: 50%;
  filter: drop-shadow(0 0 6px currentColor);
  transform: translate3d(104em, 0, 0);
  animation: fall var(--fall-duration) var(--fall-delay) linear infinite,
    tail-fade var(--tail-fade-duration) var(--fall-delay) ease-out infinite;

  @include sp-layout {
    // For mobile performance, tail-fade animation will be removed QAQ
    animation: fall var(--fall-duration) var(--fall-delay) linear infinite;
  }

  @for $i from 1 through $star-count {
    &:nth-child(#{$i}) {
      --star-tail-length: #{random_range(500em, 750em) / 100};
      --top-offset: #{random_range(0vh, 10000vh) / 100};
      --fall-duration: #{random_range(6000, 12000s) / 1000};
      --fall-delay: #{random_range(0, 10000s) / 1000};
    }
  }

  &::before,
  &::after {
    position: absolute;
    content: "";
    top: 0;
    left: calc(var(--star-width) / -2);
    width: var(--star-width);
    height: 100%;
    background: linear-gradient(45deg, transparent, currentColor, transparent);
    border-radius: inherit;
    animation: blink 2s linear infinite;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
}

@keyframes fall {
  to {
    transform: translate3d(-30em, 0, 0);
  }
}

@keyframes tail-fade {
  0%,
  50% {
    width: var(--star-tail-length);
    opacity: 1;
  }

  70%,
  80% {
    width: 0;
    opacity: 0.4;
  }

  100% {
    width: 0;
    opacity: 0;
  }
}

@keyframes blink {
  50% {
    opacity: 0.6;
  }
}
</style>
